import { type CSSProperties, type FC } from 'react';
import classnames from 'classnames';
import { type PlacementSide } from './popoverPositioning.ts';
import styles from './Popover.module.css';
import dibsCss from 'dibs-css';

export const PopoverTriangle: FC<{ side: PlacementSide; offset: number }> = ({ side, offset }) => {
    const isVertical = side === 'top' || side === 'bottom';
    const style: CSSProperties = isVertical ? { left: offset } : { top: offset };
    return (
        <svg
            className={classnames(
                styles.triangle,
                dibsCss.absolute,
                dibsCss.maxW20px,
                dibsCss.maxH20px,
                {
                    [styles.triangleTop]: side === 'top',
                    [styles.triangleBottom]: side === 'bottom',
                    [styles.triangleLeft]: side === 'left',
                    [styles.triangleRight]: side === 'right',
                }
            )}
            style={style}
            role="presentation"
            width={isVertical ? '20' : '9'}
            height={isVertical ? '9' : '20'}
            viewBox={isVertical ? '0 0 20 9' : '0 0 9 20'}
        >
            <path d={isVertical ? 'M0 0L20 0L10 9L0 0Z' : 'M9 0L9 20L0 10L9 0Z'} />
        </svg>
    );
};
